import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'

import { MdError, MdInfo, MdWarning } from 'react-icons/md'

const colors = ['black', 'brand.darkBlue', 'brand.darkGray', 'brand.red']
const lightColors = [
  'white',
  'brand.lightBlue',
  'brand.lightYellow',
  'brand.lightRed',
]
const icons = {
  3: <MdError size={16} />,
  2: <MdWarning size={16} />,
  1: <MdInfo size={16} />,
}
const MessageStack = ({ issues }) => {
  if (!issues?.length)
    return (
      <Container>
        <Text
          as="code"
          color="brand.green">
          -- No problems found --
        </Text>
      </Container>
    )
  return (
    <Container>
      {issues.map((item, index) => (
        <Box
          key={index}
          mb={1}>
          <Flex
            borderRadius={4}
            fontSize={14}
            gap={2}
            color={colors[item.type]}
            bgColor={lightColors[item.type]}
            p={2}>
            <Box
              mt={1}
              color={item.type === 2 ? 'brand.lightOrange' : colors[item.type]}>
              {icons[item.type]}
            </Box>
            <Text
              as="code"
              lineHeight={1.2}>
              {item.message}
            </Text>
          </Flex>
        </Box>
      ))}
    </Container>
  )
}

const Container = props => (
  <Box
    border="1px solid"
    borderColor="brand.gray"
    padding="16px"
    {...props}
  />
)

MessageStack.propTypes = {}

export default MessageStack
